import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import MainFeature1 from 'components/features/Nosotros.js';
export default () => {
	return (
		<AnimationRevealPage>
			<MainFeature1
				heading="Acerca de nosotras"
				buttonRounded={false}
				primaryButtonText="Contact Us"
				imageSrc="https://firebasestorage.googleapis.com/v0/b/stellar-fx-444302-f2.firebasestorage.app/o/recetas%2Fnosotras.jpeg?alt=media&token=aec70b7e-b8ae-428b-820d-aa8242cbba95"
				textOnLeft={false}
			/>
		</AnimationRevealPage>
	);
};
